<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cancel')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p *ngIf="message">{{ message }}</p>
  <div class="form-group">
    <label for="examLockPassphrase">Passphrase</label>
    <input id="examLockPassphrase" type="password" maxlength="128" class="form-control"
      [(ngModel)]="passphrase" autocomplete="off" (keydown.enter)="submit()">
  </div>
  <div class="text-danger" *ngIf="error">{{ error }}</div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="submit()">Continue</button>
</div>
